import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "../pages/Home";
import BanhoDeSemijoias from "../pages/BanhoDeSemijoias";
import BanhoDeOuroSemijoias from "../pages/BanhoDeOuroSemijoias";
import BanhoDePrataSemijoias from "../pages/BanhoDePrataSemijoias";
import GalvanoplastiaSemijoias from "../pages/GalvanoplastiaSemijoias";
import Contato from "../pages/Contato";
import Cataforetico from "../pages/Cataforetico";
import Diamond from "../pages/Diamond";
import VernizCataforetico from "../pages/Cataforetico";
import VernizDiamond from "../pages/Diamond";

function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/banho-de-ouro-semijoias" element={<BanhoDeOuroSemijoias />} />
        <Route path="/banhos-diversos" element={<BanhoDePrataSemijoias />} />
        <Route path="/vernizes/cataforetico" element={<VernizCataforetico />} />
        <Route path="/vernizes/diamond" element={<VernizDiamond />} />
        <Route path="/contato" element={<Contato />} />
      </Routes>
    </BrowserRouter>
  );
}

export default AppRouter;